import { useSyncExternalStore } from "react";
import { createBrowserRouter, matchRoutes, RouterProvider } from "react-router";
import SessionProvider from "../session/SessionProvider";
import AppShell from "../shell/AppShell";
import type { WorkspaceWindow } from "../shell/workspace/workspaceController";
import ThemeProvider from "../theme/ThemeProvider";
import { TAB_ROUTES, WINDOW_ROUTES, WORKSPACE_ROUTE_ID } from "./appRoutes";
import RequireSession from "./RequireSession";

/** The window's one browser router: its own pages, and its history, which the workspace writes too (F90). */
const router = createBrowserRouter(WINDOW_ROUTES);

const isWorkspacePath = (path: string) => matchRoutes(WINDOW_ROUTES, path)?.at(-1)?.route.id === WORKSPACE_ROUTE_ID;
const subscribe = (listener: () => void) => router.subscribe(listener);
const inWorkspace = () => router.state.matches.at(-1)?.route.id === WORKSPACE_ROUTE_ID;

const WORKSPACE_WINDOW: WorkspaceWindow = { router, isWorkspacePath };

/**
 * The window shows either one of its own pages, under its router, or the workspace, whose
 * tabs each have a router of their own: React Router allows no router inside another.
 */
export default function App() {
  const workspace = useSyncExternalStore(subscribe, inWorkspace);
  return (
    <ThemeProvider>
      <SessionProvider>
        {workspace ? (
          <RequireSession router={router}>
            {(accountId) => <AppShell key={accountId} browser={WORKSPACE_WINDOW} tabRoutes={TAB_ROUTES} accountId={accountId} />}
          </RequireSession>
        ) : (
          <RouterProvider router={router} />
        )}
      </SessionProvider>
    </ThemeProvider>
  );
}
